
export class UpdateTransactionStatus{

    transactionIds: any[];
    status: number;
    remark: string;
}


// WEBPACK FOOTER //
// ./src/app/entities/transaction-monitoring/update-transaction-status/update-transaction-model.ts